import {Locales} from '@netx/core-next/locales/utils/Locales';

export const SearchesSavedLabel = Locales((i18n) => ({
	ROUTE: i18n('i18n.savedSearches'),
}));

export const SearchSavedActionLabel = Locales((i18n) => ({
	ADD_TO_CURRENT_CART: i18n('i18n.addAllToSelection'),
	CREATE: i18n('i18n.saveSearch'),
	CREATE_PDF: i18n('i18n.createPDF'),
	CREATE_PDF_DOWNLOAD: i18n('i18n.download'),
	CREATE_PDF_SHARE_LINK: i18n('i18n.createLink'),
	DELETE: i18n('i18n.deleteSearch'),
	DOWNLOAD: i18n('i18n.download'),
	MENU: i18n('i18n.share'),
	RENAME: i18n('i18n.rename'),
	SHARE_FEED: i18n('i18n.createFeed'),
	SHARE_LINK: i18n('i18n.createLink'),
	SHARE_TEAM_ACCESS: i18n('i18n.manageTeamAccess'),
	TOGGLE_FAVORITE: i18n('i18n.toggleFavorite'),
	VIEW: i18n('i18n.edit'),
}));

export const SEARCH_SAVED_ACTION_LABELS = SearchSavedActionLabel;
